import { useState, useEffect } from "react";
import Modal from "../../components/modal/modal.jsx";
import { useNavigate } from "react-router-dom";
import api from "../../constants/api.js";
import "./posts.css";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import Postagem from "../../components/postagem/postagem.jsx";
import Swal from "sweetalert2";

function Posts() {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [texto, setTexto] = useState("");
  const [titulo, setTitulo] = useState("");
  const [loading, setLoading] = useState(true);
  const [img, setImg] = useState("");
  const [visibleCount, setVisibleCount] = useState(10);

  useEffect(() => {
    async function fetchPosts() {
      try {
        // 🔥 ROTA CERTA DO ADMIN
        const response = await api.get("/posts/admin");
        setPosts(response.data);
      } catch {
        console.log("Erro ao buscar posts");
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, []);

  function atualizarPost(id, dados) {
    setPosts(prev =>
      prev.map(p =>
        p.id_post === id ? { ...p, ...dados } : p
      )
    );
  }

  function abrirPost(id_post) {
    navigate(`/posts/admin/${id_post}`);
  }

  function editarPost(post) {
    setTitulo(post.titulo);
    setTexto(post.texto);
    setImg(post.imagem_url);
    setEditandoId(post.id_post);
    setOpen(true);
  }

 async function excluirPost(id_post) {
  const result = await Swal.fire({
    title: "Tem certeza?",
    text: "Essa ação não pode ser desfeita",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, excluir",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#e53935",
  });

  // 👇 se cancelar, sai da função
  if (!result.isConfirmed) return;

  try {
    await api.delete(`/posts/${id_post}`);

    setPosts(prev =>
      prev.filter(p => p.id_post !== id_post)
    );

    Swal.fire({
      icon: "success",
      title: "Excluído!",
      text: "Post removido com sucesso",
      timer: 1200,
      showConfirmButton: false,
    });
  } catch {
    Swal.fire(
      "Erro",
      "Não foi possível excluir o post",
      "error"
    );
  }
}


  function abrirModal() {
    setTitulo("");
    setTexto("");
    setImg("");
    setEditandoId(null);
    setOpen(true);
  }

  async function enviarPost() {
    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("texto", texto);
    if (img) formData.append("imagem", img);

    const res = await api.post("/posts", formData);

    setPosts(prev => [res.data, ...prev]);
    setOpen(false);
  }

 async function enviarEdit() {
  const formData = new FormData();
  formData.append("titulo", titulo);
  formData.append("texto", texto);

  // só envia imagem se for um arquivo novo
  if (img && typeof img !== "string") {
    formData.append("imagem", img);
  }

  const res = await api.put(`/posts/${editandoId}`, formData);

  atualizarPost(editandoId, {
    ...res.data,
    imagem_url: res.data.imagem_url
      ? `${res.data.imagem_url}?t=${Date.now()}`
      : res.data.imagem_url,
  });

  // 🔴 ISSO É IMPORTANTE (faltava no seu trecho)
  setOpen(false);
}

  const postsOrdenados = [...posts].sort((a, b) => {
  // 1️⃣ ativos primeiro
  if (a.ativo !== b.ativo) {
    return a.ativo ? -1 : 1;
  }

  // 2️⃣ ambos ativos → ordenar por ordem
  if (a.ativo && b.ativo) {
    if (a.ordem == null && b.ordem == null) return 0;
    if (a.ordem == null) return 1;
    if (b.ordem == null) return -1;
    return a.ordem - b.ordem;
  }

  // 3️⃣ ambos inativos → mantém ordem atual
  return 0;
});


  if (loading) return <p>Carregando...</p>;

  return (
    <div className="container-posts">
      <div className="header-posts">
        <h2>Publicações</h2>

        <div className="containerBtn-post">
          <button className="post-inserir" onClick={abrirModal}>
            Nova publicação
          </button>
          <BtnVoltar voltar={() => navigate("/home")} />
        </div>
      </div>

      <div className="posts">
        {postsOrdenados.slice(0, visibleCount).map(post => (
          <Postagem
            key={post.id_post}
            post={post}
            tipo="post"
            abrirPost={abrirPost}
            editarPost={editarPost}
            excluirPost={excluirPost}
            atualizarPost={atualizarPost}
          />
        ))}
      </div>

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={editandoId ? enviarEdit : enviarPost}
        texto={texto}
        setTexto={setTexto}
        titulo={titulo}
        setTitulo={setTitulo}
        img={img}
        setImg={setImg}
        tipo="post"
      />
    </div>
  );
}

export default Posts;
